import * as React from 'react';

export default React.lazy(async () => import(/* webpackChunkName: "scheduled_reports" */ './ScheduledReports'));